import React from "react";
import { FormControl, FormLabel, Input } from "@chakra-ui/react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";

const DateInput = ({ data, label, name, value, minDate, maxDate, handleInputChange, errorMessage, isDisabled }) => {
  
  const handleDateChange = (date) => {
    if (!date) {
      // When date is cleared, pass empty string
      handleInputChange({
        target: {
          name,
          value: "",
        },
      });
    } else {
      const formatted = moment(date).format("DD/MM/YYYY");
      handleInputChange({
        target: {
          name,
          value: formatted,
        },
      });
    }
  };

  const parseDate = (str) => {
    if (!str || typeof str !== "string") return null;
    const [day, month, year] = str.split("/");
    if (!day || !month || !year) return null;
    const date = new Date(year, month - 1, day);
    return isNaN(date.getTime()) ? null : date;
  };

  return (
    <FormControl isInvalid={!!errorMessage}>
      {label && <FormLabel color="#666666">{label}</FormLabel>}

      <DatePicker
        selected={value ? parseDate(value) : null}
        onChange={handleDateChange}
        minDate={minDate ? parseDate(minDate) : new Date()}
        maxDate={maxDate ? parseDate(maxDate) : undefined}
        dateFormat="dd/MM/yyyy"
        customInput={<Input variant="flushed" isDisabled={isDisabled} />}
        placeholderText="dd/mm/yyyy"
        disabled={isDisabled}
      />

      {errorMessage && (
        <p style={{ color: "red", fontSize: "12px" }}>{errorMessage}</p>
      )}
    </FormControl>
  );
};

export default DateInput;
